// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__20pnR","footer":"ModalInfo_footer__r3W6Q"};